import BaseService from "./baseClass.services";
import { apiURL } from "utils/base-url";

class LoyaltyService extends BaseService {
  // Admin endpoints
  getLoyaltySummary = async () => {
    const res = await this.axios.get(`/loyalty/summary`);
    return res.data;
  };

  getLoyaltyConfig = async (customerId) => {
    const res = await this.axios.get(`/loyalty/config/${customerId}`);
    return res.data;
  };

  updateLoyaltyConfig = async (customerId, data) => {
    delete data._id
    delete data.__v
    delete data.updatedAt

    const res = await this.axios.put(`/loyalty/config/${customerId}`, data);
    return res.data;
  };
  getLoyaltyTiers = async () => {
    const res = await this.axios.get(`/loyalty/tiers`);
    return res.data;
  };

  updateLoyaltyTiers = async (data) => {
    const payload = Array.isArray(data) ? { tiers: data } : data;
    const res = await this.axios.put(`/loyalty/tiers`, payload);
    return res.data;
  };

  toggleOverrideProtection = async (customerId, isProtected) => {
    const res = await this.axios.post(`/loyalty/tiers/override-protection`, {
      customerId,
      protected: isProtected,
    });
    return res.data;
  };

  changeCustomerTier = async (customerId, data) => {
    const res = await this.axios.put(`/loyalty/accounts/${customerId}/tier`, data);
    return res.data;
  };

  getLoyaltyAccounts = async (params) => {
    const res = await this.axios.get(`/loyalty/accounts`, { params });
    return res.data;
  };

  getLoyaltyAccount = async (customerId) => {
    const res = await this.axios.get(`/loyalty/accounts/${customerId}`);
    return res.data;
  };



  getLoyaltyTransactions = async (params) => {
    const res = await this.axios.get(`/loyalty/transactions`, { params });
    return res.data;
  };

  getCustomerTransactions = async (customerId, params) => {
    const res = await this.axios.get(`/loyalty/transactions/${customerId}`, { params });
    return res.data;
  };

  adjustPoints = async (data) => {
    const res = await this.axios.post(`/loyalty/adjust`, data);
    return res.data;
  };

  getCashbackRequests = async (params) => {
    const res = await this.axios.get(`/loyalty/cashback-requests`, { params });
    return res.data;
  };

  approveCashback = async (txnId, data) => {
    const res = await this.axios.put(`/loyalty/cashback-requests/${txnId}/approve`, data);
    return res.data;
  };

  rejectCashback = async (txnId, data) => {
    const res = await this.axios.put(`/loyalty/cashback-requests/${txnId}/reject`, data);
    return res.data;
  };

  // Customer portal endpoints
  getMyLoyaltyConfig = async () => {
    const res = await this.axios.get(`/loyalty/my-config`);
    return res.data;
  };

  getMyLoyaltyAccount = async () => {
    const res = await this.axios.get(`/loyalty/my-account`);
    return res.data;
  };

  getMyTransactions = async (params) => {
    const res = await this.axios.get(`/loyalty/my-transactions`, { params });
    return res.data;
  };

  redeemOnInvoice = async (data) => {
    const res = await this.axios.post(`/loyalty/redeem-invoice`, data);
    return res.data;
  };

  requestCashback = async (data) => {
    const res = await this.axios.post(`/loyalty/request-cashback`, data);
    return res.data;
  };
  getMyLoyaltyDashboard = async () => {
    const res = await this.axios.get(`/loyalty/my-dashboard`);
    return res.data;
  };
  exportLoyaltyTransactions = (params) => {
    const queryString = Object.keys(params)
      .map(
        (key) =>
          `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`
      )
      .join("&");
    return `${apiURL}loyalty/transactions/export?${queryString}&key=${sessionStorage.getItem(
      "userToken"
    )}`;
  };
}

export default new LoyaltyService();
